<template>
  <div>
    <tool-bar
      :title="title"
      :right-menu-actions="toolbarActionsList"
      @onActionSelected="onToolbarActionSelected"
      :showSubTitle="false"
      :showLenderCobrandingData="false"
    ></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <redirecting-message-dialog
      :show="showRedirectMessageDialog"
      ref="redirectMessageDialog"
      @onRedirect="onRedirectPartnerApp"
      @onRedirectionCancelled="onRedirectionCancelled"
    ></redirecting-message-dialog>

    <table class="w100 margin-top-10">
      <tr>
        <td class="padding-left-10">
          <!--SearhBar Componet start
          TODO : Add autherization, if required-->
          <search-bar
            :InputPlaceHolderText="searchBarInputPlaceHolder"
            @searchedQuery="searchedQuery"
          ></search-bar>
          <!--SearhBar Componet end-->
        </td>
        <td class="text-align-right padding-right-10">
          <div v-if="isAgent">
            <wxc-button
              size="small"
              type="blue"
              text="Apply New Loan"
              class="margin-0"
              :btn-style="applyNewLoanButtonStyle"
              @wxcButtonClicked="onApplyNewLoan"
            ></wxc-button>
          </div>
        </td>
      </tr>
    </table>

    <div v-if="isAgent" class="margin-top-20"></div>

    <div v-show="showLoans">
      <div v-for="ezLoan in ezLoans" :key="ezLoan.loan.id">
        <loan-item
          class="margin-top-10 margin-bottom-10 margin-left-20 margin-right-20 background-color-white"
          :ez-loan="ezLoan"
          @onLoanSelected="openLoan"
        ></loan-item>
      </div>

      <table class="w100 margin-top-10 margin-bottom-20" v-if="isAgent">
        <tr class="text-align-center">
          <td>
            <paginate
                :page-range="1"
                :pageCount="paginationPageCount"
                :containerClass="'pagination'"
                :clickHandler="onPageNumberSelected"
            ></paginate>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import LoanItem from "../../layout/LoanItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import RedirectingMessageDialog from "../../dialogs/RedirectingMessageDialog";
import ActivityNavigator, {
  Activities,
} from "../../../utils/ActivityNavigator";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import DataSource from "../../../data/DataSource";
import EzUtils from "../../../utils/EzUtils";
import PartnerAppParam from "../../../data/model/PartnerAppParam";
import PrefManager from "../../../data/model/PrefManager";
import { RolesConstants } from "../../../utils/RolesConstants";
import { ToolbarMenuItems } from "../../../utils/ToolbarMenuItems";
import { LoanStatus } from "../../../utils/LoanStatusDetails";
import SearchBar from "../../layout/SearchBar";
import { Constants } from "../../Constants";
import Paginate from 'vuejs-paginate';

export default {
  name: "HomeActivity",
  components: {
    ErrorAlertItem,
    ToolBar,
    LoanItem,
    Loading,
    WxcButton,
    RedirectingMessageDialog,
    SearchBar,
    Paginate
  },
  data: () => ({
    title: "Loans",
    showLoans: false,
    ezLoans: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRedirectMessageDialog: false,
    searchBarInputPlaceHolder: "Search here..",
    currentPageNumber: 1,
    loanOffset: 0
  }),
  methods: {
   onToolbarActionSelected(selectedAction) {
      if (ToolbarMenuItems.GO_TO_MERCHANT_APP === selectedAction) {
        this.showRedirectMessageDialog = true;
        this.$refs.redirectMessageDialog.initializeDialog();
      }
      if (ToolbarMenuItems.CHANGE_OFFICE === selectedAction) {
        ActivityNavigator.navigateTo(Activities.OFFICE);
      }
    },

    onRedirectPartnerApp() {
      if (PartnerAppParam.isPartnerCallbackWithJavaScriptInterface()) {
        // eslint-disable-next-line no-undef
        partnerCallback.openPartnerApp();
      } else {
        window.location = "https://stage-finance.piggyride.in/app/v1/redirect";
      }
    },

    onRedirectionCancelled() {
      this.showRedirectMessageDialog = false;
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    openLoan(ezLoan) {
      LoanScopeDataHolder.setDetailsFromEzLoan(ezLoan);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    onApplyNewLoan() {
      LoanScopeDataHolder.clearLoanScopeData();
      ActivityNavigator.navigateTo(Activities.CUSTOMER_PHONE_NUMBER);
    },

    isLoanRejected(ezLoan) {
      return EzUtils.areEqualString(LoanStatus.REJECTED, this.getLoanStatus(ezLoan), true);
    },

    getLoanStatus(ezLoan) {
      if (ezLoan && ezLoan.loan && ezLoan.loan.status
        && ezLoan.loan.status.value) {
        return ezLoan.loan.status.value;
      }
      return "";
    },

    fetchLoansForPageNo(pageNumber) {
      if (pageNumber > 0) {
        this.loanOffset = (pageNumber - 1) * 10;
        this.ezLoans = [];
        this.fetchLoans();
      }
    },

    fetchLoans() {
      LoanScopeDataHolder.clearLoanScopeData();
      this.loading = true;
      const offset = this.isAgent ? this.loanOffset : null;
      const limit = this.isAgent ? 10 : null;
      const officeId = this.isAgent ? PrefManager.getUserOfficeId() : null;
      const staffConfig = PrefManager.getStaffConfig();
      const staffId = staffConfig && EzUtils.isTrue(staffConfig.is_self_staff)
          ? PrefManager.getStaffId() : null;
      DataSource.getLoansForStages(offset, limit, null, null, "id", "DESC", staffId, officeId, Constants.LOAN_APPLICACTION_TYPE_MAIN)
        .then(loansData => {
          this.loading = false;
          if (loansData.errorOccurred) {
            this.showError(loansData.data);
          } else {
            this.ezLoans = loansData.data;
            if (!this.isAgent
              && this.ezLoans.length === 1
              && !this.isLoanRejected(this.ezLoans[0])
            ) {
              this.openLoan(this.ezLoans[0])
            } else {
              this.showLoans = true
            }
          }
        })
    },

    searchedQuery(query) {
      if(query && query.trim()){
        this.loading = true;
        const resource = Constants.CLIENTS+","+Constants.LOANS;
        DataSource.getLoanByResources(query.trim(),resource,true)
        .then((loansData) => {
          if (loansData.errorOccurred) {
            this.showError(loansData.data);
          } else {
            this.ezLoans = loansData.data;
          }
          this.loading = false;
        });
      }else{
        this.fetchLoans();
      }
    },

    onPageNumberSelected(pageNumber) {
      this.currentPageNumber = pageNumber;
      this.fetchLoansForPageNo(pageNumber);
    }
  },

  created: function () {
    this.fetchLoans();
  },

  computed: {
    toolbarActionsList() {
      const toolbarActions = [
        ToolbarMenuItems.CONTACT_SUPPORT,
        ToolbarMenuItems.LOGOUT,
      ];
      if (PartnerAppParam.isPartnerAppCallback()) {
        toolbarActions.push(ToolbarMenuItems.GO_TO_MERCHANT_APP);
      }
      if (PrefManager.isMultipleOfficePresent()) {
        toolbarActions.push(ToolbarMenuItems.CHANGE_OFFICE);
      }
      return toolbarActions;
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    paginationPageCount() {
      return this.currentPageNumber + 5;
    },

    applyNewLoanButtonStyle() {
      return { width: "120px" };
    },
  },
};
</script>

<style src="../../../assets/style/base.css"></style>
